import { render } from "./sms.vue?vue&type=template&id=288f028a"
import script from "./sms.vue?vue&type=script&lang=js"
export * from "./sms.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__